import { create } from 'zustand';
import type { AdoptionSummary } from '@/features/adoption/adoption';
import type { ReadinessResult } from '@/features/oversharing/readiness';
import type { LicenseResult } from '@/features/licenses/licenses';
import type { LabelCoverageResult } from '@/features/labels/labelCoverage';

/**
 * Cross-module derived results (§7). C6's exec summary reads whatever the other
 * modules have produced this session. In-memory only — nothing is persisted or
 * sent anywhere (zero-egress).
 */
interface ResultsState {
  adoption: AdoptionSummary | null;
  readiness: ReadinessResult | null;
  licenses: LicenseResult | null;
  labelCoverage: LabelCoverageResult | null;
  setAdoption: (a: AdoptionSummary | null) => void;
  setReadiness: (r: ReadinessResult | null) => void;
  setLicenses: (l: LicenseResult | null) => void;
  setLabelCoverage: (c: LabelCoverageResult | null) => void;
}

export const useResults = create<ResultsState>((set) => ({
  adoption: null,
  readiness: null,
  licenses: null,
  labelCoverage: null,
  setAdoption: (adoption) => set({ adoption }),
  setReadiness: (readiness) => set({ readiness }),
  setLicenses: (licenses) => set({ licenses }),
  setLabelCoverage: (labelCoverage) => set({ labelCoverage }),
}));
